import React, { useState } from "react";
import style from "../../DashboardForms/CommonStyles/commonformstyles.module.scss";
import { useNavigate } from "react-router-dom";

function CallbackForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    message: "",
    preferredTime: "",
  });

  const [errorMessage, setErrorMessage] = useState("");

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.name || !formData.phoneNumber || !formData.email) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    console.log("📤 Submitting Callback Request:", formData);

    setFormData({
      name: "",
      phoneNumber: "",
      email: "",
      message: "",
      preferredTime: getTomorrowDate(),
    });

    navigate("/dashboard");
  };

  return (
    <div className={style.dashboardFormContainerWrapper}>
      <div className={style.dashboardFormContainer}>
        <form className={style.FormContainer} onSubmit={handleSubmit}>
          <h2 className={style.dashboardFormContinerHeading}>
            Request a Callback
          </h2>
          <p className={style.noEquipmentDescription}>
            Our team is ready to assist you. Simply provide your information,
            and we'll get in touch shortly.
          </p>

          <div className={style.dashboardFormInputLabelField}>
            <label className={style.dashFormContainerLabel} htmlFor="name">
              Name
            </label>
            <input
              id="name"
              name="name"
              placeholder="Enter your full name"
              type="text"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className={style.dashboardFormInputLabelField}>
            <label
              className={style.dashFormContainerLabel}
              htmlFor="phoneNumber"
            >
              Phone Number
            </label>
            <input
              id="phoneNumber"
              name="phoneNumber"
              placeholder="Enter your phone number"
              type="tel"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className={style.dashboardFormInputLabelField}>
            <label className={style.dashFormContainerLabel} htmlFor="email">
              Email
            </label>
            <input
              id="email"
              name="email"
              placeholder="Enter your email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className={style.dashboardFormInputLabelField}>
            <label className={style.dashFormContainerLabel} htmlFor="message">
              Brief Message
            </label>
            <textarea
              id="message"
              name="message"
              placeholder="Tell us about your request (optional)"
              value={formData.message}
              onChange={handleInputChange}
            ></textarea>
          </div>

          <div className={style.dashboardFormInputLabelField}>
            <label
              className={style.dashFormContainerLabel}
              htmlFor="preferredTime"
            >
              Preferred Time for Tomorrow
            </label>
            <input
              id="preferredTime"
              name="preferredTime"
              type="time"
              value={formData.preferredTime}
              onChange={handleInputChange}
              required
            />
          </div>

          {errorMessage && <p className={style.errorMessage}>{errorMessage}</p>}

          <div className={style.btnContainer}>
            <button className={style.dashboardFormSaveButtonDown} type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CallbackForm;
